/**
 * @generated SignedSource<<a5a21f9634b819d49dabf17885fd7720>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery$variables = {};
export type personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment">;
};
export type personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery = {
  response: personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery$data;
  variables: personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonalizedNotificationTemplatesConnection",
                "kind": "LinkedField",
                "name": "GetPersonalizedNotificationTemplates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedNotificationTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedNotificationTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NotificationTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": (v0/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "connection",
                "key": "personalizedNotificationTemplatesTable_GetPersonalizedNotificationTemplates",
                "kind": "LinkedHandle",
                "name": "GetPersonalizedNotificationTemplates"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationTemplate",
                "kind": "LinkedField",
                "name": "GetAvailableNotificationTemplates",
                "plural": true,
                "selections": (v0/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6dfd9fcaf795d1151197a9acd19392d6",
    "id": null,
    "metadata": {},
    "name": "personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery",
    "operationKind": "query",
    "text": "query personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery {\n  ...personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment\n}\n\nfragment createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment on Query {\n  Admin {\n    Notification {\n      GetAvailableNotificationTemplates {\n        key\n        title\n      }\n    }\n  }\n}\n\nfragment personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment on PersonalizedNotificationTemplate {\n  id\n  template {\n    key\n    title\n  }\n}\n\nfragment personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment on Query {\n  Admin {\n    Notification {\n      GetPersonalizedNotificationTemplates {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            ...personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment\n            id\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n  ...createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment\n}\n"
  }
};
})();

(node as any).hash = "5031002113031c00a17acdc4e2dfda61";

export default node;
